<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import HomeSlideshow from '../components/home/HomeSlideshow.vue'
import AuthModal from '../components/auth/AuthModal.vue'
import { api } from '../api/Api'
import { useRoute } from 'vue-router'
import { useNotificationStore } from '../stores/notification'
import { tokenManager } from '../api/utils/tokenManager'
const notificationStore = useNotificationStore()
const steps = [
  { id: 1, title: 'Creating Company', caption: 'Setting up your company profile...' },
  { id: 2, title: 'Configuring Database', caption: 'Initializing your database...' },
  { id: 3, title: 'Setting Up Defaults', caption: 'Configuring sefaults...' },
  { id: 4, title: 'Setting Up Storage', caption: 'Preparing file storage system...' },
  { id: 5, title: 'Finalizing', caption: 'Completing setup and verification...' },
  { id: 6, title: 'Completed', caption: 'Compant has been configured, Click Login to start using...' }
]

const currentStep = ref(1)
const showLoginModal = ref(false)
const isComplete = ref(false)

const progress = ref(0)
//const currentCaption = ref('Preparing to Start the Setup')
const currentCaption = computed(() => {
  return steps[currentStep.value - 1]?.caption || ''
})


const error = ref('')

const route = useRoute()
onMounted(async () => {
    currentStep.value = 1
    console.log(route.params)
    if (route.params.id == '') {
        error.value = 'Invalid Link or Activation Code'
        return;
    }
    const param = route.params.id;
    const params = (param as string).split("+")
    const apiData = {
        code: params[0],
        company: params[1]
    }
    const response = await api.post('activate-email', apiData,  {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      skipLoading: true
    })
    .catch(err => {
      console.log(err)
      error.value = err.response?.data?.errors || 'An unknown error occurred'
    })
    console.log(response)
    if (response && response.success == true) {
        currentStep.value++
        progress.value = 20
        createCompany(params[0], params[1])
    } else {
        error.value = response?.errors || 'An unknown error occurred'
    }
    
})
const createCompany = async (code: string, company: string) =>
{
    const apiData = {
        code: code,
        company: company
    }
    await api.post('create-company', apiData,  {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      skipLoading: true
    })
    .then (response => {
        if (response.success == true) {
            currentStep.value++
            progress.value = 40
            createDatabase(code, company)
        } else {
            error.value = response.message || 'An unknown error occurred'
        }
    })
    .catch(err => {
        error.value = err.message
    })
}
const createDatabase = async (code: string, company: string) =>
{
    const apiData = {
      code: code,
      company: company
    }
    await api.post('create-database', apiData,  {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      skipLoading: true
    })
    .then (response => {
        if (response.success == true) {
            currentStep.value++
            progress.value = 60
            createDefaults(code, company)
        } else {
            error.value = response.message || 'An unknown error occurred'
        }
    })
    .catch(err => {
        error.value = err.message
    })
}
const createDefaults = async (code: string, company: string) =>
{
    const apiData = {
      code: code,
      company: company
    }
    await api.post('create-defaults', apiData,  {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      skipLoading: true
    })
    .then (response => {
        if (response.success == true) {
            currentStep.value++
            progress.value = 80
            createStorage(code, company)
        } else {
            error.value = response.message || 'An unknown error occurred'
        }
    })
    .catch(err => {
        error.value = err.message
    })
}
const createStorage = async (code: string, company: string) =>
{
    const apiData = {
      code: code,
      company: company
    }
    await api.post('create-storage', apiData,  {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      skipLoading: true
    })
    .then (response => {
        if (response.success == true) {
            currentStep.value++
            progress.value = 100
            notificationStore.addNotification({
                title: 'Company Ready!',
                message: 'Thank you for choosing FaseyhaPOS, you are now ready to start using FaseyhaPOS. click Login below.',
                type: 'info',
                action: {
                    label: 'Login',
                    onClick: () => {
                        showLoginModal.value = true
                    }
                }
            })
            tokenManager.setMessage('company_registration_completed')
            window.location.href = '/'
        } else {
            error.value = response.message || 'An unknown error occurred'
        }
    })
    .catch(err => {
        error.value = err.message
    })
}

</script>

<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4">
    <div class="max-w-4xl mx-auto">
      <!-- Progress Section -->
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 mb-8">
        <h1 class="text-2xl font-bold text-gray-900 dark:text-white text-center mb-8">
          Creating Your Company
        </h1>

        <!-- Error Alert -->
        <div 
            v-if="error"
            class="p-4 flex rounded-md bg-red-50 dark:bg-red-900/50 border border-red-200 dark:border-red-800"
        >
            <p class="text-sm  py-2 px-4 text-center text-red-800 dark:text-red-200">{{ error }}</p>
            <button
                @click="showLoginModal = true"
                class="mt-10 py-2 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
                If you already have activated you emaill, try Log In to Continue
            </button>
        </div>

        <!-- Progress Bar -->
        <div class="relative pt-1 mb-6">
          <div class="h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
            <div
              class="h-full bg-blue-600 transition-all duration-500 ease-out rounded-full"
              :style="{ width: `${progress}%` }"
            ></div>
          </div>
          <div class="mt-2 text-center text-sm text-gray-600 dark:text-gray-400">
            {{ Math.round(progress) }}% Complete
          </div>
        </div>

        <!-- Current Step Caption -->
        <div class="text-center">
          <p class="text-lg font-medium text-gray-900 dark:text-white mb-2">
            {{ steps[currentStep - 1]?.title }}
          </p>
          <p class="text-gray-600 dark:text-gray-400">
            {{ currentCaption }}
          </p>
        </div>

        <!-- Complete State -->
        <div v-if="isComplete" class="mt-8 text-center">
          <div class="w-16 h-16 bg-green-100 dark:bg-green-900/50 rounded-full flex items-center justify-center text-3xl mx-auto mb-4">
            ✓
          </div>
          <h2 class="text-xl font-semibold text-gray-900 dark:text-white mb-2">
            Setup Complete!
          </h2>
          <p class="text-gray-600 dark:text-gray-400 mb-6">
            Your company has been successfully created. You can now log in to your account.
          </p>
          <button
            @click="showLoginModal = true"
            class="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Log In to Continue
          </button>
        </div>
      </div>

      <!-- Slideshow Section -->
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
        <h2 class="text-xl font-semibold text-gray-900 dark:text-white mb-6">
          While we set up your company...
        </h2>
        <HomeSlideshow />
      </div>
    </div>

    <!-- Login Modal -->
    <AuthModal
      v-if="showLoginModal"
      @close="showLoginModal = false"
    />
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>